// extracted by mini-css-extract-plugin
module.exports = {"inline":"styles_inline__fAfxv"};